/**
 * index.tsx
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import FontFaceObserver from 'fontfaceobserver';

// Use consistent styling
import 'sanitize.css/sanitize.css';

import { App } from 'app';

import { HelmetProvider } from 'react-helmet-async';

import { configureAppStore } from 'store/configureStore';

import { ThemeProvider } from 'styles/theme/ThemeProvider';

import { StylesProvider } from '@mui/styles';

import MuiThemeProvider from '@mui/material/styles/ThemeProvider';

import MuiTheme from 'styles/theme/MuiTheme';

import reportWebVitals from 'reportWebVitals';

import DateAdapter from '@mui/lab/AdapterMoment';

import LocalizationProvider from '@mui/lab/LocalizationProvider';

// Initialize languages
import './locales/i18n';

// Observe loading of Poppins (to remove 'Poppins', remove the <link> tag in
// the index.html file and this observer)
const openSansObserver = new FontFaceObserver('Poppins', {});

// When Poppins is loaded, add a font-family using Poppins to the body
openSansObserver.load().then(() => {
  document.body.classList.add('fontLoaded');
});

const store = configureAppStore();
const MOUNT_NODE = document.getElementById('root') as HTMLElement;

ReactDOM.render(
  <Provider store={store}>
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={MuiTheme}>
        <ThemeProvider>
          <HelmetProvider>
            <React.StrictMode>
              <LocalizationProvider dateAdapter={DateAdapter}>
                <App />
              </LocalizationProvider>
            </React.StrictMode>
          </HelmetProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </StylesProvider>
  </Provider>,
  MOUNT_NODE,
);

// Hot reloadable translation json files
if (module.hot) {
  module.hot.accept(['./locales/i18n'], () => {
    // No need to render the App again because i18next works with the hooks
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
